import { Controller } from "@hotwired/stimulus";

// Connects after a successful POST to /order_items (Turbo Stream response).
// The modal is rendered server-side via turbo_stream.update 'modal',
// so this controller is a lightweight hook for any client-side follow-up
// (e.g. resetting form state, analytics not covered by push_ga4_event).
export default class extends Controller {
  static values = { orderItemId: Number };

  connect() {
    // No-op: the success modal opens automatically via turbo_stream.update 'modal'
    // from create.turbo_stream.erb. GA4 event is pushed server-side.
  }
}
